import { render, staticRenderFns } from "./nav-lang.vue?vue&type=template&id=2084738c&scoped=true"
import script from "./nav-lang.vue?vue&type=script&lang=js"
export * from "./nav-lang.vue?vue&type=script&lang=js"
import style0 from "./nav-lang.vue?vue&type=style&index=0&id=2084738c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084738c",
  null
  
)

export default component.exports